import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HasRoleDirective} from './directives/has-role.directive';
import {HasRolePipe} from './pipes/has-role.pipe';


@NgModule({
  declarations: [
    HasRoleDirective,
    HasRolePipe
  ],
  exports: [
    HasRoleDirective,
    HasRolePipe
  ],
  imports: [
    CommonModule,
  ]
})
export class RoleModule {
}
